import { Tooltip2 } from "@blueprintjs/popover2"
import { Icon, Info } from "@phosphor-icons/react"
import React from "react"
import clsx from "utils/clsx"

type CardTpe = {
  title: string
  Icon: Icon
  text:  React.ReactNode
  info?: String
  subtext: React.ReactNode
  intent?: "primary" | "success" | "warning"
}

export const card = ({
  title,
  Icon,
  info,
  text,
  subtext,
  intent = "primary",
}: CardTpe) => {
  return (
    <div
      className={clsx(
        intent === "primary"
          ? "bg-gradient-to-r from-[#EEF5FF]  to-[#DBEAFE]"
          : intent === "warning"
          ? "bg-gradient-to-r from-[#FFFAE5] to-[#FFEDD4]"
          : intent === "success"
          ? "bg-gradient-to-r from-[#ECFCF2] to-[#DCFCE7]"
          : "",
        "p-4 rounded-2xl"
      )}
    >
      <div className="flex justify-between items-center">
        <p className="text-gray-600">
          {title}{" "}
          {info && (
            <Tooltip2
              content={<p>{info} </p>}
              placement="top"
              minimal
              intent="primary"
              popoverClassName="bg-white "
            >
              <Info color="#1447E6" />
            </Tooltip2>
          )}
        </p>

        <Icon
          size={20}
          className={
            intent === "primary"
              ? "text-[#1447E6]"
              : intent === "success"
              ? "text-[#008236]"
              : intent === "warning"
              ? "text-[#BB4D00]"
              : ""
          }
        />
      </div>
      <div
        className={clsx(
          intent === "primary"
            ? "text-[#1447E6]"
            : intent === "success"
            ? "text-[#008236]"
            : intent === "warning"
            ? "text-[#BB4D00]"
            : "",
          "font-500 text-xl"
        )}
      >
        {text}
      </div>
      <div
        className={clsx(
          intent === "primary"
            ? "text-[#1447E6]"
            : intent === "success"
            ? "text-[#008236]"
            : intent === "warning"
            ? "text-[#BB4D00]"
            : ""
        )}
      >
        {subtext} 
      </div>
    </div>
  )
}
